/**
 * TTS language_code 可选值映射（语言名 -> 代码）。
 * 用于前端展示可选语言与提交参数值。
 * 来自https://docs.kie.ai/market/elevenlabs/text-to-dialogue-v3
 */
export const TTS_LANGUAGE_CODE_MAP = {
  Afrikaans: 'af',
  Arabic: 'ar',
  Assamese: 'as',
  Azerbaijani: 'az',
  Belarusian: 'be',
  Bengali: 'bn',
  Bosnian: 'bs',
  Bulgarian: 'bg',
  Catalan: 'ca',
  Cebuano: 'ceb',
  Chichewa: 'ny',
  Croatian: 'hr',
  Czech: 'cs',
  Danish: 'da',
  Dutch: 'nl',
  English: 'en',
  Estonian: 'et',
  Filipino: 'fil',
  Finnish: 'fi',
  French: 'fr',
  Galician: 'gl',
  Georgian: 'ka',
  German: 'de',
  Greek: 'el',
  Gujarati: 'gu',
  Hausa: 'ha',
  Hebrew: 'he',
  Hindi: 'hi',
  Hungarian: 'hu',
  Icelandic: 'is',
  Indonesian: 'id',
  Irish: 'ga',
  Italian: 'it',
  Japanese: 'ja',
  Javanese: 'jv',
  Kannada: 'kn',
  Kazakh: 'kk',
  Kyrgyz: 'ky',
  Korean: 'ko',
  Latvian: 'lv',
  Lingala: 'ln',
  Lithuanian: 'lt',
  Luxembourgish: 'lb',
  Macedonian: 'mk',
  Malay: 'ms',
  Malayalam: 'ml',
  Chinese: 'zh',
  Marathi: 'mr',
  Nepali: 'ne',
  Norwegian: 'no',
  Pashto: 'ps',
  Persian: 'fa',
  Polish: 'pl',
  Portuguese: 'pt',
  Punjabi: 'pa',
  Romanian: 'ro',
  Russian: 'ru',
  Serbian: 'sr',
  Sindhi: 'sd',
  Slovak: 'sk',
  Slovenian: 'sl',
  Somali: 'so',
  Spanish: 'es',
  Swahili: 'sw',
  Swedish: 'sv',
  Tamil: 'ta',
  Telugu: 'te',
  Thai: 'th',
  Turkish: 'tr',
  Ukrainian: 'uk',
  Urdu: 'ur',
  Vietnamese: 'vi',
  Welsh: 'cy',
} as const
